var YouboraObject = function () {}

YouboraObject.prototype = {
  /**
   * A base class that other Classes should inherit from.
   * It has a no-op constructor intended to be overridden by classes that extend from this.
   *
   * @constructs YouboraObject
   * @abstract
   * @memberof youbora
   */
  constructor: function () {}
}

/**
 * This static method allows the extension of the current class, emulating 1-level inheritance.
 * Also add a helper __super__ object poiting to the parent prototypes methods
 * @see https://github.com/SBoudrias/class-extend
 * @example
 * var A = YouboraObject.extend({ a: 1, b: 1, c: { d: 0 } });
 * var a = new A(); // { a: 1, b: 1, c: { d: 0 } }
 *
 * var B = A.extend({ b: 2, c: { e: 3 } });
 * var b = new B(); // { a: 1, b: 2, c: { e: 3 } }
 *
 * @param  {Object} protoProps  Prototype properties (available on the instances)
 * @param  {Object} staticProps Static properties (available on the contructor)
 * @return {Object}             New sub class
 */
YouboraObject.extend = function (protoProps, staticProps) {
  var parent = this
  var NewClass

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && Object.prototype.hasOwnProperty.call(protoProps, 'constructor')) {
    NewClass = protoProps.constructor
  } else {
    NewClass = function () { return parent.apply(this, arguments) }
  }

  // Add static properties to the constructor function, if supplied.
  Object.assign(NewClass, parent, staticProps)

  // Set the prototype chain to inherit from `parent`
  NewClass.prototype = Object.create(parent.prototype, {
    constructor: {
      value: NewClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  })

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) Object.assign(NewClass.prototype, protoProps)

  // Set a convenience property in case the parent's prototype is needed
  // later.
  NewClass.__super__ = parent.prototype

  return NewClass
}

module.exports = YouboraObject



//////////////////
// WEBPACK FOOTER
// ./src/object.js
// module id = 1
// module chunks = 0